import { render, staticRenderFns } from "./MaterialPicker.vue?vue&type=template&id=346b6619&scoped=true"
import script from "./MaterialPicker.vue?vue&type=script&lang=js"
export * from "./MaterialPicker.vue?vue&type=script&lang=js"
import style0 from "./MaterialPicker.vue?vue&type=style&index=0&id=346b6619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b6619",
  null
  
)

export default component.exports